import { getWebsiteFaviconConfig, getWebsiteLatestConfig, getWebsiteLogoConfig } from '@/service/config'
import { useEffect, useState } from 'react'

export function useCustomWebsiteLogo() {
  const [websiteLogo, setWebsiteLogo] = useState<string | null>(null)
  useEffect(() => {
    getWebsiteLogoConfig().then(res => {
      if (res && res.value) {
        setWebsiteLogo(res.value)
      }
    })
  }, [])
  return websiteLogo
}

export function useCustomWebsiteTitle() {
  const [title, setTitle] = useState<string | null>(null)
  useEffect(() => {
    getWebsiteLatestConfig('title').then(res => {
      if (res && res.value) {
        setTitle(res.value)
      }
    })
  }, [])
  return title
}

export function useCustomWebsiteFavicon(isLTC: boolean) {
  const [websiteFavicon, setWebsiteFavicon] = useState<string | null>(null)
  useEffect(() => {
    if (!isLTC) {
      return
    }
    getWebsiteFaviconConfig().then(res => {
      if (res && res.value) {
        setWebsiteFavicon(res.value)
      }
    })
  }, [])
  return websiteFavicon
}
